var exports = {
  "Kd": "vendorIcon__vl2TLA",
};

module.exports = exports;
